/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { getAppFlavourCards } from '../../routes/home/partials/cards';
import { getDefaultConfig } from '../../config/app-config';
import { useSelector } from 'react-redux';
import { RootState, useAppSelector } from '../../reducers';
import { Button } from 'reactstrap';
import { useAppClickHandlers } from '../../hooks/useAppClickHandlers';
import DisambiguationModal, { DisambiguationModalProps } from '../../routes/home/partials/DisambiguationModal';
import { isStaff } from '../../selectors/user';

const AppsMenu = ({ toggleRequestDemoModal }: { toggleRequestDemoModal: () => void }) => {

  const [disambiguationModal, setDisambiguationModal] = useState<DisambiguationModalProps | undefined>(undefined);
  const isLoggedIn = useSelector((state: RootState) => state.currentUser.loaded);
  const isUserStaff = useAppSelector(isStaff);

  const [isOpen, setOpen] = useState(false);
  const cards = getAppFlavourCards(getDefaultConfig().flavour, isLoggedIn, isUserStaff).filter(card => card.solutions);
  const clickHandlers = useAppClickHandlers({ toggleRequestDemoModal, shouldOpenInNewTab: true, setDisambiguationModal })

  const closeOnComplete = (callback: () => void) => {
    callback();
    setOpen(false);
  }

  return (
    <div className='apps-menu'>
      {disambiguationModal ? <DisambiguationModal {...disambiguationModal} /> : null}
      <Button className='apps-menu-button' color={isOpen ? 'secondary' : 'transparent'} onClick={() => setOpen(!isOpen)}>
        <i className='fa-solid fa-grid' />
      </Button>
      <div className={`apps-menu-blur ${isOpen ? 'visible' : 'invisible'}`} onClick={() => setOpen(false)} />
      <div className={`apps-menu-menu ${isOpen ? 'visible' : 'invisible'}`}>
        <h4 className='ml-3 text-ThemeHeadingLight'>Solutions</h4>
        <div className='d-flex flex-wrap'>
          {cards
            .map((card, i) => (
              <div
                key={`header-card-${i}`}
                className='apps-menu-card d-flex justify-content-center'
                onClick={() => card.clickHandler ? closeOnComplete(clickHandlers[card.clickHandler]) : {}}>
                <div
                  className='hp-card-logo d-flex align-items-center '>
                  <img src={card.logo} alt={'Logo'} width='125' />
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}

export default AppsMenu;
